import { useAppConfig } from '@/redux/features/app-config/hooks';
import { useCallback, useLayoutEffect } from 'react';

// This components switches the app theme based on the darkMode value from the app config.
// It uses useLayoutEffect to ensure the theme is applied before the browser paints as well
// as avoids flickering and re-rendering when mode is changed.
export const AppThemeListener = () => {
  const { darkMode } = useAppConfig();
  const toggleTheme = useCallback(() => {
    document.querySelector('html')?.classList.toggle('dark', darkMode);
  }, [darkMode]);

  useLayoutEffect(toggleTheme, [toggleTheme]);

  return null;
};
